import React, { useState, useCallback, useEffect } from "react";

import swal from "sweetalert";
import { Form, Input, FormField, FormGroup, Button } from "semantic-ui-react";

import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import Footer from "../../../../components/Footer";

import { producaov2 } from "../../../../services/apis";

import { Container, Box, Header, FormBlock, TableContainer } from "./styles";

import Table from "../../../../components/Table/templates/inscricoes";
import Controls from "../../../../components/Controls";
import Axios from "axios";
import { systemLogs } from "../../../../services/system_logs";
import CursosSelector from "../../../../components/Admin/CursosSelector";

const RelatorioInscricoes = () => {
  document.title = "Painel Administrativo | Grupo Voitto";

  const [curso, setCurso] = useState("");
  const [options, setOptions] = useState([]);

  const [dataInicio, setDataInicio] = useState("");
  const [dataFinal, setDataFinal] = useState("");
  const [idCurso, setIdCurso] = useState("");
  const [loading, setLoading] = useState(false);
  const [relatorio, setRelatorio] = useState(false);
  const [inscricoes, setInscricoes] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);

  const handleGenerateReport = useCallback(async () => {
    setLoading(true);
    setRelatorio(false);

    console.log("OBJ: ", { dataInicio, dataFinal, idCurso });

    try {
      const res = await producaov2.post("/admin/reports/pesquisa", {
        data_inicio: dataInicio,
        data_final: dataFinal,
        id_curso: idCurso,
      });

      setRelatorio(res.data.url);
      setLoading(false);

      await systemLogs(
        "Relatorio",
        `Gerou o relatorio de NPS entre ${dataInicio} e ${dataFinal}}`
      );

      swal("Confirmado!", "Relatório gerado com sucesso", "success");

      window.open(res.data.url, "blank");
    } catch (error) {
      console.log(error);

      setLoading(false);

      if (!error.response) {
        return;
      }

      swal(`Algo deu errado`, `Se persistir, contate nosso suporte`, "error");
    }
  }, [dataInicio, dataFinal, idCurso]);

  const handleChange = (event, value) => {
    setPage(value);
  };

  return (
    <div style={{width: "100vw", paddingLeft:"250px"}}>
      <AdminMenu />
      <Container>
        <Header>Relatório de Pesquisa (NPS)</Header>
        <Box>
        <a
          href="/admin/relatorios/pesquisa-mba"
          style={{
            textAlign:"right",
            width:"100%",
            color: "#1b1c1d",
            textDecoration:"underline"
          }}
        >Pesquisa de satisfação MBA</a>
          <Form>
            <FormBlock>
              <p>Selecionar período</p>
              <FormField>
                A partir de
                <Input
                  onChange={(e) => setDataInicio(e.target.value)}
                  type="date"
                />
                até
                <Input
                  onChange={(e) => setDataFinal(e.target.value)}
                  type="date"
                />
                Curso
                <CursosSelector handleChange={setIdCurso} />
              </FormField>
            </FormBlock>

            <FormGroup>
              <Button
                color="orange"
                onClick={handleGenerateReport}
                loading={loading}
              >
                Gerar Relatório
              </Button>
              {relatorio && (
                <Button
                  style={{ minWidth: "80px" }}
                  onClick={() => window.open(relatorio, "_blank")}
                  color="green"
                >
                  Baixar Relatório
                </Button>
              )}
            </FormGroup>
          </Form>
        </Box>
      </Container>
      <Footer />
    </div>
  );
};

export default RelatorioInscricoes;
